import { createContext, ReactNode, useContext } from 'react';

interface UserAgentContextType {
  userAgent: string;
}

const UserAgentContext = createContext<UserAgentContextType | undefined>(undefined);

interface UserAgentProviderProps {
  children: ReactNode;
  userAgent: string;
}

export const UserAgentProvider = ({ children, userAgent }: UserAgentProviderProps) => {
  return <UserAgentContext.Provider value={{ userAgent }}>{children}</UserAgentContext.Provider>;
};

export const useUserAgent = (): UserAgentContextType => {
  const context = useContext(UserAgentContext);
  if (context === undefined) {
    // eslint-disable-next-line no-console
    console.warn(
      'useUserAgent must be used within a UserAgentProvider. Returning default user agent.',
    );
    return { userAgent: '' };
  }
  return context;
};
